import './index.css'
import Button from '../button'
import TagGradient from '../tag-gradient';
import { useState } from 'react';

function HomepageHero(){
    const navigateToLoginPage = () => {
        window.location.href = '/signup';
    }

    const navigateToPricing = () => {
        document.getElementById("pricing-holder").scrollIntoView({
            behavior: 'smooth', // Defines the scrolling behavior
            block: 'start', // Aligns the element at the start of the scrollable area (can be 'start', 'center', 'end', or 'nearest')
            inline: 'nearest' // Aligns the element horizontally (can be 'start', 'center', 'end', or 'nearest')
        });
        
    }

    return (
        <div className='homepage-abovefold-holder'>
        <TagGradient text='Meet your inspiration engine' />
        <h1 className='big-text homepage-title'>Boost Your Reach<br></br>
        <span className='highlight-green'>By 224.5%</span></h1>
        <p className='small-text description-of-service'>Mako helps you monitor websites, draft content ideas and organise your posting schedule, all in one place.</p>
        <div className='cta-bar'>
        <Button addedFunction={navigateToLoginPage} text='Start 7 day free trial'></Button>
        <Button text='Pricing' addedFunction={navigateToPricing}></Button>
        </div>

        </div>
)
}

export default HomepageHero